import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import { injectReducer } from "store/reducers";
import Engagement from "./routes/Engagement";
import Performance from "./routes/Performance";
import Behaviour from "./routes/Behaviour";
import ModuleUsage from "./routes/ModuleUsage";
import Settings from "./routes/Settings";
import Attendance from "./routes/Attendance";
import AIAnalytics from "./routes/AIAnalytics";
import PinnedDashboards from "./routes/PinnedDashboards";
import AIAnalyticsV2 from "./routes/AIAnalyticsV2";
import Dashboards from "./routes/Dashboards";
import PinnedDashboardsV2 from "./routes/PinnedDashboardsV2";
import ChatHistory from "./routes/ChatHistory";
import ExternalDataSources from "./routes/ExternalDataSources";

export default store => ({
  path: "toddle-insights",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "toddle-insights" */ "./components"),
        import(
          /* webpackChunkName: "toddle-insights" */ "ToddleAnalytics/modules/ToddleAnalyticsModule"
        ),
      ]).then(([importedModule0, importedModule1]) => {
        const component = importedModule0.default;
        const reducer = importedModule1.default;
        injectReducer(store, {
          key: "toddleAnalytics",
          reducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    Engagement(store),
    Performance(store),
    Behaviour(store),
    ModuleUsage(store),
    Settings(store),
    Attendance(store),
    AIAnalytics(store),
    ChatHistory(store),
    ExternalDataSources(store),
    PinnedDashboards(store),
    AIAnalyticsV2(store),
    Dashboards(store),
    PinnedDashboardsV2(store),
  ],
});
